export default __webpack_public_path__ + "static/media/elevate-cbb-poster-2.0a7ad426.jpg";